<template>
    <div class="order-groups">
        <div class="cart-header">
            <div class="cart-item1"><span>{{$t('user_center_order_product')}}</span></div>
            <div class="cart-item2"><span>{{$t('user_center_order_price')}}</span></div>
            <div class="cart-item3"><span>{{$t('user_center_order_Quantity')}}</span></div>
            <div class="cart-item5"><span>{{$t('order_amount_paid')}}</span></div>
            <div class="cart-item4"><span>{{$t('user_center_order_order_status')}}</span></div>
            <div class="cart-item6"><span>{{$t('user_center_order_operation')}}</span></div>
        </div>
        <div class="order-list" v-for="(order,index) in orderList">
            <div class="pc-order-list">
                <div class="order-row-header">
                    {{$t('user_center_order_order_num')}}：
                    <router-link :to="{name:'MyDetails',params:{order_sn:order.order_sn}}">{{order.order_sn}}
                    </router-link>
                </div>
                <div class="order-row">
                    <div class="order-row-goods">
                        <div class="goods-list" v-for="(item,i) in order.order_detail">
                            <div class="goods-header goods-item">
                                <img :src="item.goods_img">
                            </div>
                            <div class="goods-desc-group">
                                <div class="goods-desc goods-item">
                                    <h3>{{item.goods_name}}</h3>
                                    <div style="max-width: 200px;font-size: 16px;">
                                        {{item.product_introduction}}
                                    </div>
                                </div>
                                <div class="goods-price goods-item">{{item.goods_unit}} {{item.goods_price}}</div>
                                <div class="goods-num goods-item">
                                    <span>{{item.goods_num}}</span>
                                </div>
                            </div>
                            <div class="order-status-operation">
                                <div class="order-status">
                                    <div class="goods-price goods-item" v-if="i==0"><span style="color: #0084ff;">{{item.goods_unit}} {{order.need_pay_usd_price}}</span><div style="font-size: 16px;">({{$t('order_freight')}}:{{order.shipping_price}})</div></div>
                                </div>
                                <div class="order-status" >
                                    <p class="goods-item" v-if="i==0">{{filterStatus(order.order_status)}}</p>
                                    <p v-if="i==0">
                                        <router-link :to="{name:'MyDetails',params:{order_sn:order.order_sn}}">
                                            {{$t('user_center_order_order_details')}}
                                        </router-link>
                                    </p>
                                </div>
                                <div class="order-operation goods-item">
                                    <div class="operation-group" v-if="order.order_status == 0">
                                        <p v-if="i==0"><a href="javascript:;" class="btn btn-primary operation-pay"
                                              @click="checkOut(order.order_sn)">{{$t('payment_btn')}}</a></p>
                                        <p v-if="i==0"><a @click="openCancelModel(order.order_sn)">{{$t('user_center_order_cancel_order')}}</a>
                                        </p>
                                    </div>
                                    <div class="goods-item" v-if="order.order_status ==2 || order.order_status == 3 || order.order_status == 1">
                                        <p class="goods-item" v-if="i==0"><a @click="confirmOrder(order.order_sn)" style="color: #0084ff;">{{$t('user_order_confirm')}}</a></p>
                                    </div>
                                    <div class="goods-item" v-if="order.order_status == 4">
                                        <div v-if="i==0">
                                            <p class="goods-item" v-if="order.end_status === true">
                                                <router-link style="color: red;" :to="{name:'MyDetails',params:{order_sn:order.order_sn}}">
                                                    {{$t('user_center_order_return_exchange')}}
                                                </router-link>
                                            </p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mobile-order-list">
                <div class="order-row-header">
                    {{$t('user_center_order_order_num')}}：
                    <router-link :to="{name:'MyDetails',params:{order_sn:order.order_sn}}">{{order.order_sn}}
                    </router-link>
                </div>
                <div style="background: #F9FCFF;width: 100%;padding: 5px">
                    <div class="order-row" v-for="(item,i) in order.order_detail" :key="i">
                        <div class="goods-header">
                            <img :src="item.goods_img">
                        </div>
                        <div class="goods-desc">
                            <h3>
                                {{item.goods_name}}
                            </h3>
                            <p>${{item.goods_price}}  x  {{item.goods_num}}</p>
                            <div class="goods-status">
                                <span>{{filterStatus(order.order_status)}}</span>
                                <span>
                                    <router-link :to="{name:'MyDetails',params:{order_sn:order.order_sn}}">
                                        {{$t('user_center_order_order_details')}}
                                    </router-link>
                                </span>
                            </div>
                            <div class="goods-operation">
                                <div class="operation-group" v-if="order.order_status == 0">
                                    <p><a href="javascript:;" class="btn btn-primary operation-pay"
                                          @click="checkOut(order.order_sn)">{{$t('payment_btn')}}</a></p>
                                    <p><a @click="openCancelModel(order.order_sn)">{{$t('user_center_order_cancel_order')}}</a>
                                    </p>
                                </div>
                                <div class="" v-if="order.order_status ==2 || order.order_status == 3 || order.order_status == 1">
                                    <p><a @click="confirmOrder(order.order_sn)">{{$t('user_order_confirm')}}</a></p>
                                </div>
                                <div class="" v-if="order.order_status == 4">
                                    <p>
                                        <router-link :to="{name:'MyDetails',params:{order_sn:order.order_sn}}">
                                            {{$t('user_center_order_return_exchange')}}
                                        </router-link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <modal v-model="showCancel"
               :title="$t('user_center_order_cancel_order')"
               style="text-align: center"
               @on-ok="cancelOrder">
            <p>{{$t('user_center_order_cancel_order_tip')}}</p>
            <input type="hidden" style="display: none" v-model="cancelOrderNumber">
        </modal>
    </div>
</template>
<script>
    import Signature from '../../../lib/Signature'
    import PayType from '../../../lib/PayType'
    import modal from '../../Common/Modal.vue'

    class Status {
        static NOT_PAY = 0
        static WAIT_FOR_DELIVERY = 1
        static DELIVERYED = 2
        static TRANSPORTING = 3
        static COMPLETED = 4
        static CENCELLED = 5
        static PENDING = 6
        static Replacing = 7
        static RETURN_COMPLETED = 8
    }

    export default {
        data () {
            return {
                showCancel: false,
                cancelOrderNumber: ''
            }
        },
        props: {
            orderList: Array
        },
        components: {
            modal
        },
        methods: {
            confirmOrder (orderSn) {
                let module = 'index.php/confirm'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.order_sn = orderSn
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseFloat(resp.data.code) === 2000) {
                            // 成功刷新页面
                            this.$router.go(0)
                        }
                    }.bind(this))
            },
            openCancelModel (sn) {
                this.showCancel = true
                this.cancelOrderNumber = sn
            },
            checkOut (sn) {
                let module = 'index.php/index/pay/orderpay'
                let data = {}
//                let newTab = window.open('about:blank')
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.type = PayType.VISA
                data.order_sn = sn
                data.redirect_url = 'http://' + window.location.host + '/#/user/order/' + sn + '/success'
                data.redirect_error_url = 'http://' + window.location.host + '/#/personal/order/ongoing'
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        window.location.href = resp.data.data.notify_url
                    }.bind(this))

            },
            cancelOrder () {
                let module = 'index.php/index/order/cancelorder'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.user_id = this.Local.getUserId()
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.order_sn = this.cancelOrderNumber
                this.$http.post(process.env.BASEURL + module, data)
                    .then(function (resp) {
                        if (parseInt(resp.data.code) === 2000) {
                            for (let item of this.orderList) {
                                if (item.order_sn === this.cancelOrderNumber) {
                                    item.order_status = 5
                                    this.showCancel = false
                                    break
                                }
                            }
                        }
                    }.bind(this))
            },
            filterStatus (value) {
                let statusName
                switch (parseInt(value)) {
                    case Status.NOT_PAY:
                        statusName = this.$t('user_order_not_pay')
                        break
                    case Status.WAIT_FOR_DELIVERY:
                        statusName = this.$t('user_order_not_for_deli')
                        break
                    case Status.DELIVERYED:
                        statusName = this.$t('user_order_delivered')
                        break
                    case Status.CENCELLED:
                        statusName = this.$t('user_order_canceled')
                        break
                    case Status.TRANSPORTING:
                        statusName = this.$t('user_order_transporting')
                        break
                    case Status.COMPLETED:
                        statusName = this.$t('user_order_completed')
                        break
                    case Status.PENDING:
                        statusName = this.$t('user_order_pending')
                        break
                    case Status.Replacing:
                        statusName = this.$t('user_order_returning')
                        break
                    case Status.RETURN_COMPLETED:
                        statusName =this.$t('user_order_return_completed')
                        break
                }
                return statusName
            }
        }
    }

</script>
<style scoped lang="scss">
    .order-groups {
            .cart-header{
                max-width: 1240px;
                width: 100%;
                .goods-header{
                    min-width: 150px;
                }
                div{
                    font-size: 14px;
                    text-align: center;
                    display: inline-block;
                    color:#5E6D82;
                }
                .cart-item1{
                    width: 30%;
                }
                .cart-item2{
                    width: 20%;
                }
                .cart-item3{
                    width: 10%;
                }
                .cart-item4{
                    width: 11%;
                }
                .cart-item5{
                    width: 12%;
                }
                .cart-item6{
                    width: 15%;
                }
            }

        }

        .order-list {
        /*border-bottom: 1px solid #eeeeee;*/
        .order-row-header {
            font-size: 16px;
            color: #1F2D3D;
            padding-left:30px;
            letter-spacing: 0;
            line-height: 24px;
            a{
                color: #1F2D3D;
            }
        }
        .order-row {
            background: #F9FCFF;
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            margin-bottom: 20px;
        & > div {
                flex: 1;
        &.order-row-goods {
             flex: 4;
         }
        }
        .order-row-goods {
            border-bottom:1px solid #D3DCE6;
            margin-right: 10px;
            .goods-list {
                    display: flex;
                    max-width: 1240px;
                    width: 100%;
                    .goods-header{
                        img{
                            min-width: 100px;
                            max-width: 150px;
                            width: 100%;
                        }
                    }
                    .goods-item{
                        text-align: center;
                        padding:20px 0 0 0;
                        color: #1F2D3D;
                        a{
                            color: #1F2D3D;
                        }
                        a:hover{
                            color: #0084FF;
                        }
                    }
                    .goods-desc-group{
                        display: flex;
                        width: 50%;
                        padding: 20px 0 20px 0;
                        border-bottom: 2px solid #eee;
                        .goods-desc{
                            width: 37%;
                            text-align: left;
                        }
                        .goods-price{
                            width: 42.5%;
                        }
                        .goods-num{
                            width: 20.5%;
                        }
                    }

                    .order-status-operation{
                        width: 40%;
                        display: flex;
                        .order-status{
                            width: 50%;
                        }
                        .order-operation{
                            width: 50%;
                        }
                    }

                }

            }

        .goods-desc {
            h3 {
                font-size: 16px;
                color: #1F2D3D;
                letter-spacing: 0;
                line-height: 24px;
            }
            p {
                font-size: 16px;
                color: #5E6D82;
                letter-spacing: 0;
                line-height: 20px;
            }

        }
        .goods-price, .goods-num {
            font-size: 24px;
            padding-top: 50px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 26px
        }
        .order-status {
            padding: 30px 0;
            height: 100%;
            width: 20%;
            text-align: center;
            font-size: 16px;
            border-right: 2px solid #eee;
            border-left: 2px solid #eee;
            p{
                color: #5E6D82;
            }
            a{
                color: #1F2D3D;
            }
            a:hover{
                color: #0084ff;
            }
        }
        .goods-num .goods-num-editable {
            display: flex;
            align-items: center;
        .number {
            min-width: 20px;
            display: inline-block;
            text-align: center;
            margin: 0 5px;
        }
        button {
            border: none;
            padding: 3px 15px;
            color: #fff;
        i {
            vertical-align: middle;
        }
        }
        .minus {
            border-bottom-left-radius: 5px;
            border-top-left-radius: 5px;
            background: #D3DCE6;
        &:active {
             background: darken(#D3DCE6, 10%)
         }
        }
        .plus {
            border-bottom-right-radius: 5px;
            border-top-right-radius: 5px;
            background-color: #0084FF;
        &:active {
             background: darken(#0084FF, 10%)
         }
        }
        }
        .text-primary {
            color: #0084FF;
        }
        .order-operation {
            font-size: 16px;
            color: #5E6D82;
            letter-spacing: 0;
            line-height: 24px;
            align-self: flex-start;
            padding: 30px 0;
            .operation-pay {
                padding: 4px 20px;
            }
            .operation-group {
                p {
                    margin-bottom: 15px;
                }
            }
        }
        }
        .goods-checkbox {
            display: flex;
            margin-left: 8px;
            align-items: center;
        }
        .mobile-order-list {
            display: none;
        }
    }

    @media only screen and (max-width: 768px) {
        .order-groups{
            .pc-order-list{
                display: none;
            }
            .mobile-order-list{
                display: block;
            }
            .cart-header{
                display: none;
            }
            .order-row{
                display: flex;
                margin: 15px;
                border-bottom: 1px solid #e6e6e6;
                .goods-header{
                    width: 35%;
                    img{
                        width: 100%;
                        max-width: 170px;
                        min-width: 100px;
                    }
                }
                .goods-desc{
                        width: 65%;
                        padding-left: 20px;
                        text-align: left;
                        h3{
                            font-size: 16px;
                            a{
                                float: right;
                                padding-right: 10px;
                            }
                        }
                        p{
                            margin: 5px 10px 5px 0;
                            font-size: 16px;
                        }
                        .goods-num {
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;
                            .goods-price{
                                font-size: 16px;
                                padding-left: 25px;
                            }
                        }
                        .goods-status{
                            margin-bottom:10px;
                            border-bottom:1px solid #e6e6e6;
                            span{
                                font-size: 14px;
                                a{
                                    margin-left: 10px;
                                }
                            }
                        }
                }
            }
        }
    }




</style>



// WEBPACK FOOTER //
// Orders.vue?6074162d